
<form *ngIf="form" [formGroup]="form">
    <h2 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>Destinatarios</h2>
    <mat-dialog-content class="flex flex-col" >
        <div class="flex flex-col sm:flex-row">
            <mat-form-field class="flex-auto">
                <mat-label>Comercial</mat-label>
                <input formControlName="user" matInput>
            </mat-form-field>
            <mat-form-field class="sm:ml-6 flex-auto">
                <mat-label>Destinatario</mat-label>
                    <input type="text" matInput formControlName="receiver" placeholder="Seleccionar destinatario" [matAutocomplete]="autoContacts">
                    <mat-autocomplete #autoContacts="matAutocomplete">
                        <mat-option *ngFor="let contact of contacts" [value]="contact.email">
                            {{ contact.name }} - {{ contact.email }}
                        </mat-option>
                    </mat-autocomplete>
            </mat-form-field>

            <span class="sm:ml-6 flex items-center">
                <mat-checkbox *ngIf="this.broker.length > 0" (change)="changeReceiver($event.checked)" color="primary">Enviar a broker</mat-checkbox>
            </span>
        </div>
        <div class="w-full mt-6">
            <mat-form-field class="w-full">
                <mat-label class=".mat-tab-label.mat-tab-label-active">Mensaje</mat-label>
                <textarea tabindex="-1" matInput formControlName="sendMessage" rows="4"></textarea>
            </mat-form-field>
        </div>
    </mat-dialog-content>
    <div mat-dialog-actions align="end" >
        <button mat-button (click)="closeDialog()">Cancelar</button>
        <button color="primary" mat-flat-button [disabled]="!form.valid" (click)="send()" cdkFocusInitial>Enviar</button>
    </div>
</form>